import React from 'react';
import { ForwardCurve } from '@components';

const PegForwardCurve = () => {
    return (
        <ForwardCurve
            title="PEG Forward Curve"
            rootPath="/static/files/csv/index/forward_curve/peg/"
            breadcrumbRootLabel="peg-forward-curve"
            downloadProduct="PEG"
            downloadType="ma_index"
            searchPlaceholders={{
                0: 'Search currency folder (e.g. EUR)',
                1: 'Search year folder (e.g. 2026)',
                2: 'Search month folder (e.g. 03 or March)',
                3: 'Search filename (e.g. peg_da_index.csv)',
                default: 'Search filename or date'
            }}
            levelLabels={{
                0: 'Currency',
                1: 'Year',
                2: 'Month',
                3: 'File',
                default: 'Folder'
            }}
        />
    );
};

export default PegForwardCurve;
